import { TContentHubButton, StringField } from "../../../types/types";
import { TContentHubSeriesOverviewProps } from "../types/ContentHubSeriesOverview.type";

export class OverviewTextModel {
  private readonly fields?;

  constructor(props: TContentHubSeriesOverviewProps) {
    this.fields = props.fields || null;
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow };
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title };
  }

  get description(): StringField {
    return {
      value: this.fields?.apiData?.description,
    };
  }

  get primaryLink(): TContentHubButton {
    return this.fields?.apiData?.button1;
  }

  get secondaryLink(): TContentHubButton {
    return this.fields?.apiData?.button2;
  }
}
